import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title = 'Sonic Tours Japan - Japan Tourism',
    description = 'Discover Japan with Sonic Tours Japan. We offer curated Japan tourism experiences, cultural journeys, city tours, and personalized travel planning in Tokyo and across Japan.',
    keywords = 'Sonic Tours Japan, Japan Tourism, Japan Travel, Tokyo Tours, Kyoto Tours, Japan Tour Packages, Cultural Tours Japan, Private Japan Tours',
    image = '%PUBLIC_URL%/logo.png',
    url = 'https://sonictoursjp.com',
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Sonic Tours Japan" />
            <meta name="geo.region" content="JP" />
            <meta name="geo.placename" content="Tokyo, Japan" />
            <meta name="geo.position" content="35.6762;139.6503" />
            <meta name="ICBM" content="35.6762, 139.6503" />
            <meta name="contact:street_address" content="2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo, Japan" />
            <meta name="contact:phone_number" content="+81 90-8251-4053" />
            <meta name="contact:email" content="vbuddika@sonictourssl.com" />
            <meta name="contact:website" content="https://sonictoursjp.com" />

            {/* Open Graph (Facebook, WhatsApp, LinkedIn, etc.) */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Sonic Tours Japan" />

            {/* Twitter / X Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Optional extra tags for better SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;